import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-agentic-platform',
  name: 'Access Agentic Platform',
  category: 'access-integrations',
  description: 'Invoke AI agents and retrieve analytics from the Access Agentic Platform',
  icon: 'Bot',
  color: 'violet',
  version: '1.0.0',

  defaults: {
    name: 'Access Agentic Platform',
    color: '#8b5cf6', // Violet color
  },

  comingSoon: false,
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  tags: ['access', 'agentic', 'ai', 'agent', 'middleware', 'invoke', 'analytics'],

  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'access_agentic_platform',
    description:
      'Invoke AI agents and retrieve analytics from the Access Agentic Platform. Supports agent invocation with messages and attachments, and admin analytics for usage tracking.',
    allowManualDescription: false,
    parameters: {
      operation: {
        toolParamName: 'operation',
        description:
          'The operation to perform: invokeAgent, invokeAgentWithAttachments, invokeAgentStream, invokeAgentStreamWithAttachments, invokeAgentStreamAgUi, getAnalyticsSummary, getTeamsAnalytics, getTeamAgentsAnalytics, or getModelsAnalytics',
        required: true,
        type: 'string',
      },
      agentId: {
        toolParamName: 'agentId',
        description: 'The ID of the agent to invoke (required for invoke operations)',
        required: false,
        type: 'string',
      },
      message: {
        toolParamName: 'message',
        description: 'The message/prompt to send to the agent (required for invoke operations)',
        required: false,
        type: 'string',
      },
      conversationId: {
        toolParamName: 'conversationId',
        description: 'Optional conversation ID for maintaining context across invocations',
        required: false,
        type: 'string',
      },
      teamId: {
        toolParamName: 'teamId',
        description:
          'Team ID for filtering analytics (optional for summary/teams/models, required for team agents)',
        required: false,
        type: 'string',
      },
      startDate: {
        toolParamName: 'startDate',
        description: 'Start date for analytics filter (ISO 8601 format)',
        required: false,
        type: 'string',
      },
      endDate: {
        toolParamName: 'endDate',
        description: 'End date for analytics filter (ISO 8601 format)',
        required: false,
        type: 'string',
      },
    },
    outputMapping: {
      success: 'Whether the operation succeeded',
      operation: 'The operation that was performed',
      agentId: 'The agent ID (for invoke operations)',
      data: 'The response data from the API',
      count: 'Number of items (for list operations)',
    },
  },
};

export default definition;
